import { render } from "./OneCocktailComponent.vue?vue&type=template&id=c3781338&scoped=true"
import script from "./OneCocktailComponent.vue?vue&type=script&lang=js"
export * from "./OneCocktailComponent.vue?vue&type=script&lang=js"

import "./OneCocktailComponent.vue?vue&type=style&index=0&id=c3781338&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3781338"]])

export default __exports__